export default __webpack_public_path__ + "static/media/Floor510MintTowerBuildingMain.0769e5c5.svg";